import type { Dir, SpacingLevel, XAlignment, YAlignment } from "#lib/components/page/editing/types.js";

export const DEFAULT_HBOX_CONFIG = { direction: "col", class: "grid grid-flow-col auto-cols-fr gap-x-2" };

export const DEFAULT_TOP_LEVEL_VBOX_CONFIG = { direction: "row", class: "gap-y-4 flex flex-col grow" };

export const DEFAULT_INNER_VBOX_CONFIG = { direction: "row", class: "gap-y-2 flex flex-col" };

export const SPACING_TOKENS: Record<Dir, Record<SpacingLevel, string>> = {
	col: { none: "gap-x-0", small: "gap-x-2", medium: "gap-x-4", large: "gap-x-6" },
	row: { none: "gap-y-0", small: "gap-y-2", medium: "gap-y-4", large: "gap-y-6" },
};

export const X_ALIGNMENT_TOKENS: Record<Dir, Record<XAlignment, string>> = {
	col: { left: "justify-start", center: "justify-center", right: "justify-end" },
	row: { left: "items-start", center: "items-center", right: "items-end" },
};

export const Y_ALIGNMENT_TOKENS: Record<Dir, Record<YAlignment, string>> = {
	col: { top: "items-start", center: "items-center", bottom: "items-end" },
	row: { top: "justify-start", center: "justify-center", bottom: "justify-end" },
};

// Component types that own the full page width, so they never sit beside another component in a row. A Form
// owns page-level navigation and a video keeps its aspect ratio.
export const FULL_WIDTH_COMPONENTS = ["Form", "VideoEmbed", "Poll"];

// Types that can't be a layout column or stack inside an h-box cell. The full-width types plus Box, which is
// plumbing we never drop in by hand.
export const RESTRICTED_NESTED_COMPONENTS = [...FULL_WIDTH_COMPONENTS, "Box"];

// Editor page builder hover controls for h-box and v-box component wrappers, and the page's top-level v-box container.
const EDITOR_CONTROL_WIDTH = 24; // matches the `w-6` control buttons
const EDITOR_HOVER_OUTLINE_WIDTH = 2; // matches the 2px hover highlight outline
export const EDITOR_CONTROL_GUTTER = EDITOR_CONTROL_WIDTH + EDITOR_HOVER_OUTLINE_WIDTH;
// Per-nesting-level step so each deeper level's highlight and controls sits further in,
// so an ancestor's box and controls surround and clear its descendants' and stay reachable.
export const EDITOR_DEPTH_STEP = 8;
